export function StageTimeline({ stages, currentStage, testId }) {
  const currentIndex = stages.indexOf(currentStage);
  return (
    <div className="flex items-start justify-between" data-testid={testId || "stage-timeline"} title="Shows where this deal currently sits in the pipeline — filled circles are stages already completed.">
      {stages.map((stage, i) => (
        <div key={stage} className="flex-1 flex flex-col items-center relative">
          {i < stages.length - 1 && (
            <div
              className={`absolute top-4 left-1/2 w-full h-0.5 ${i < currentIndex ? "bg-igc-gold" : "bg-igc-gold/15"}`}
              style={{ zIndex: 0 }}
            />
          )}
          <div
            className={`relative z-10 w-8 h-8 rounded-full flex items-center justify-center border-2 text-xs font-medium ${
              i <= currentIndex ? "bg-igc-gold border-igc-gold text-black" : "bg-igc-surface border-igc-gold/25 text-igc-muted"
            }`}
          >
            {i + 1}
          </div>
          <p className={`text-xs mt-3 text-center px-1 ${i <= currentIndex ? "text-igc-cream" : "text-igc-muted"}`}>{stage}</p>
        </div>
      ))}
    </div>
  );
}
